import { createAction } from '@reduxjs/toolkit'
import { DashboardRecentTripsByPeriod } from 'redux/mapIntelligence/mapIntelligenceTypes'

const getDashboardBulkData = createAction('dashboard/getDashboardBulkData')

const getDashboardMapData = createAction('dashboard/getDashboardMapData')

const getDashboardMapDataSuccess = createAction<DashboardRecentTripsByPeriod>(
  'dashboard/getDashboardMapDataSuccess'
)

const getDashboardTrackers = createAction('dashboard/getDashboardTrackers')

const getDashboardProgramStats = createAction(
  'dashboard/getDashboardProgramStats'
)

const getDashboardProgramCards = createAction(
  'dashboard/getDashboardProgramCards'
)

const getDashboardLocationCards = createAction(
  'dashboard/getDashboardLocationCards'
)

const getDashboardLocationDetail = createAction<string>(
  'dashboard/getDashboardLocationDetail'
)

const getDashboardProgramDetail = createAction<string>(
  'dashboard/getDashboardProgramDetail'
)

const getDashboardTransitExceptions = createAction(
  'dashboard/getDashboardTransitExceptions'
)

const updateDashboardTransitExceptionStatus = createAction<{
  id: string
  status: 'OPEN' | 'RESOLVED'
}>('dashboard/updateDashboardTransitExceptionStatus')

// Must differ from the slice reducer type (`dashboard/clearDashboardLocationDetail`)
// or the clear saga will put the same action type and loop forever.
const clearDashboardLocationDetail = createAction(
  'dashboard/clearLocationDetail'
)

// Must differ from the slice reducer type (`dashboard/clearDashboardProgramDetail`).
const clearDashboardProgramDetail = createAction(
  'dashboard/clearProgramDetail'
)

export const dashboardActions = {
  getDashboardBulkData,
  getDashboardMapData,
  getDashboardMapDataSuccess,
  getDashboardTrackers,
  getDashboardProgramStats,
  getDashboardProgramCards,
  getDashboardLocationCards,
  getDashboardLocationDetail,
  getDashboardProgramDetail,
  getDashboardTransitExceptions,
  updateDashboardTransitExceptionStatus,
  clearDashboardLocationDetail,
  clearDashboardProgramDetail,
}
